import xtend from 'xtend';
// import _ from 'underscore';
// import ObjectDiff from '../../lib/store/util'.Difference;
// import queryString from '../../utils/QueryString';
// import Query from '../../events/query/Query';
// var noop = function noop () {};

// @XXX make this nicer after changing the view code. This is messy because
// we are returning the object shape that the view depends on
function EventsListActions (bus) {
    var _rootActions = [
        'search',
        'filterChange',
        'resetFilters',
        'shiftError',
        'shiftMessage',
        'pageChange',
        'get',
        'toggleActiveEvent',
        'quickFilter',
        'editKeywords'
    ];

    var rootActions = _rootActions.reduce(function (acc, act) {
        acc[act] = function () {
            return bus.emit.apply(bus,
                [act].concat(Array.prototype.slice.call(arguments)));
        };
        return acc;
    }, {});

    var _actions = {
        events: [
            'add', 'delete',
            'start', 'stop',
            'edit',
            'miscAssetToEvent',
            'publish', 'unpublish'
        ],
        encoders: ['add', 'delete', 'edit', 'get', 'getXMLConfigURI'],
        assets: ['add', 'edit', 'editLink', 'delete', 'get',
            'miscAssetToEvent','assignThumbnail', 'getMiscAssets'],
        metamarkers: ['add', 'edit', 'delete', 'get'],
        player: ['add', 'edit', 'delete', 'get', 'setPreferenceAsDefault'],
        facebookLive: ['add', 'edit', 'delete', 'get'],

        chat: ['createModerator', 'deleteModerator', 'getModerators',
                'getEventDetails', 'updateChatSettings', 'validateEmailSecret'],

        streamTargets: [
            'add', 'delete', 'edit',
            'getAltProviders', 'getAltDestinations',
            'addPending',
        ],

        transcript: [
            'create',
            'resubmit',
            'setUseAsCaptions',
            'setUsetext',
            'getWebvtt',
            'getSrt',
            'getText',
            'getTranscriptInfo',
            'getTranscript',
            'delete',

            // ----view stuff ----
            'toggleModal'
        ],

        restrictedDomains: [
            'add',
            'delete'
        ],

        audioDescription: [
            'getProject'
        ]
    };

    var actions = Object.keys(_actions).reduce(function (acc, k) {
        acc[k] = _actions[k].reduce(function (_acc, act) {
            _acc[act] = function () {
                var args = Array.prototype.slice.call(arguments);
                if (args[0] === undefined) args[0] = null;
                return bus.emit.apply(bus, [k + '.' + act].concat(args));
            };
            return _acc;
        }, {});
        return acc;
    }, {});

    var _metadata = ['categories', 'keywords', 'locations', 'technicians']
        .reduce(function (acc, m) {
            acc[m] = ['add', 'edit', 'get', 'delete']
                .reduce(function (_acc, act) {
                    _acc[act] = function () {
                        var args = Array.prototype.slice.call(arguments);
                        return bus.emit.apply(bus,
                            ['metadata' + '.' + m + '.' + act].concat(args));
                    };
                    return _acc;
                }, {});
            return acc;
        }, {})
    ;
    _metadata.analytics = createFns(['get', 'getMostWatched',
        'getUpcomingEvents'], bus, 'metadata.analytics')
    ;

    var actions = xtend(rootActions, xtend(actions, { metadata: _metadata }));
    return actions;
}

function createFns (list, bus, prefix) {
    return list.reduce(function (acc, k) {
        acc[k] = function () {
            var args = Array.prototype.slice.call(arguments);
            return bus.emit.apply(bus, [prefix + '.' + k].concat(args));
        };
        return acc;
    }, {});
}

export default EventsListActions;
